var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.copy(_vm.link)}}},on),[_c('v-icon',[_vm._v("mdi-link")])],1)]}}])},[_c('span',[_vm._v("Copy link")])])
}
var staticRenderFns = []

export { render, staticRenderFns }